import { clsx } from "@trydig/ui";
import type { SVGProps } from "react";
import spinner from "./Spinner.module.css";

const SvgComponent = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		stroke="var(--svg-color, currentColor)"
		strokeLinecap="round"
		strokeLinejoin="round"
		strokeWidth={2}
		viewBox="0 0 24 24"
		className={clsx(spinner.spinner, className)}
		{...props}
	>
		<title>Loading</title>
		<path d="M12 2v4M16.2 7.8l2.9-2.9M18 12h4M16.2 16.2l2.9 2.9M12 18v4M4.9 19.1l2.9-2.9M2 12h4M4.9 4.9l2.9 2.9" />
	</svg>
);

export { SvgComponent as Spinner };
